module.exports = __webpack_public_path__ + "static/media/chevronLeft.dd5ab421.svg";